import { takeLatest } from 'redux-saga/effects';
import {
	getTimecardUpdateRequestListSuccess, getTimecardUpdateRequestListFail,
	getTimecardUpdateRequestDetailsSuccess, getTimecardUpdateRequestDetailsFail,
    approveTimecardUpdateRequest,  approveTimecardUpdateRequestSuccess,
    approveTimecardUpdateRequestFail, rejectTimecardUpdateRequest,
    rejectTimecardUpdateRequestSuccess, rejectTimecardUpdateRequestFail,
} from "./timecardUpdateRequestState";
import createCrudService from '../../services/crudservice';
import { 
	doCrudCall, SAVING_MSG, UPDATING_MSG, DELETING_MSG, LOADING_MSG,
	createRecordSuccess, updateRecordSuccess, deleteRecordSuccess
} from '../../utils/crudSagaHelper';

const crudService = createCrudService("api/v1/timekeeping/timecard-update-requests");
const redirectData = {route: "/console/timecard-update-requests", mode: 'list', recordId:0 };
const modelName = "Timecard Update Request";
const modelId = "tur_id";

function* getTimecardUpdateRequestList(action) {
	const filters = action.payload;

	yield doCrudCall(
		() => crudService.getList(filters),
		(responseData) =>
			getTimecardUpdateRequestListSuccess({
				...responseData,
				filters,
			}),
		getTimecardUpdateRequestListFail,
		null,
		null,
		LOADING_MSG
	);
}

function* getTimecardUpdateRequestDetails(action) {
	yield doCrudCall(
		() => crudService.getDetails(action.payload),
		getTimecardUpdateRequestDetailsSuccess,
		getTimecardUpdateRequestDetailsFail,
		null,
		null,
		LOADING_MSG
	);
}

function* doTimecardUpdateRequestCreate(action) {
	yield doCrudCall(
		() => crudService.doCreate(action.payload),
		getTimecardUpdateRequestDetailsSuccess,
		getTimecardUpdateRequestDetailsFail,
		createRecordSuccess(modelName),
		null,
		SAVING_MSG
	);
}

function* doTimecardUpdateRequestUpdate(action) {
	yield doCrudCall(
		() => crudService.doUpdate(
			action.payload[modelId],
			action.payload
		),
		getTimecardUpdateRequestDetailsSuccess,
		getTimecardUpdateRequestDetailsFail,
		updateRecordSuccess(modelName),
		redirectData,
		UPDATING_MSG
	);
}

function* doTimecardUpdateRequestDelete(action) {
	yield doCrudCall(
		() => crudService.doDelete(action.payload.recordId),
		getTimecardUpdateRequestDetailsSuccess,
		getTimecardUpdateRequestDetailsFail,
		deleteRecordSuccess(modelName),
		{
			...redirectData,
			mode: action.payload.mode,
		},
		DELETING_MSG
	);
}

function* approveTimecardUpdateRequestSaga(data) {
    const { tur_id } = data.payload;

    yield doCrudCall(
        () => crudService.doPostRequest(`${tur_id}/approve`, data.payload),
        getTimecardUpdateRequestDetailsSuccess,
        getTimecardUpdateRequestDetailsFail,
        updateRecordSuccess(modelName),
        { ...redirectData, mode: "reload" },
        "Approving request..."
    );
}

function* rejectTimecardUpdateRequestSaga(data) {
    const { tur_id } = data.payload;

    yield doCrudCall(
        () => crudService.doPostRequest(`${tur_id}/reject`, data.payload),
        getTimecardUpdateRequestDetailsSuccess,
        getTimecardUpdateRequestDetailsFail,
        updateRecordSuccess(modelName),
        { ...redirectData, mode: "reload" },
        "Rejecting request..."
    );
}


function* timecardUpdateRequestSaga() {
	yield takeLatest("timecardUpdateRequest/getTimecardUpdateRequestList",
		getTimecardUpdateRequestList);
	yield takeLatest("timecardUpdateRequest/getTimecardUpdateRequestDetails",
		getTimecardUpdateRequestDetails);
	yield takeLatest("timecardUpdateRequest/doTimecardUpdateRequestCreate",
		doTimecardUpdateRequestCreate);
	yield takeLatest("timecardUpdateRequest/doTimecardUpdateRequestUpdate",
		doTimecardUpdateRequestUpdate);
	yield takeLatest("timecardUpdateRequest/doTimecardUpdateRequestDelete",
		doTimecardUpdateRequestDelete);
	yield takeLatest(approveTimecardUpdateRequest.type,
		approveTimecardUpdateRequestSaga);
	yield takeLatest(rejectTimecardUpdateRequest.type,
    	rejectTimecardUpdateRequestSaga);
}

export default timecardUpdateRequestSaga;
